export const isCNPJSearchTerm = (value = '') => {
	const trimmed = value.trim();
	const normalized = CNPJ(trimmed).unmask;

	return !!normalized && /^[A-Za-z0-9./-]+$/.test(trimmed) && /\d/.test(normalized);
};
